import React from 'react';

const AWS_Intro = () => {
  return (
    <div>
      <h1>AWS_Intro</h1>
      <p>This is the AWS_Intro component.</p>
    </div>
  );
};

export default AWS_Intro;
